import { createRouter, createWebHistory } from 'vue-router'

import { registerGuards } from './guards'
import { routes } from './routes'

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    // Moving between lessons should not throw the learner back to the top of
    // the page; the player manages its own scroll.
    if (to.name === 'course-player' && from.name === 'course-player') return false
    return { top: 0 }
  },
})

registerGuards(router)

export default router
